<div class="pagamento-comanda">
  <div class="pagamento-cabecalho">
    <div class="pagamento-titulo">
      <span class="icone-titulo"><i class="fas fa-wallet"></i></span>
      <strong>Forma de Pagamento</strong>
    </div>

  </div>

  <div class="alert alert-warning mb-3" *ngIf="pagamentoBloqueadoPorPixOnline()">
    <i class="fas fa-lock mr-1"></i>
    Pix gerado. Cancele o Pix para alterar a forma de pagamento.
    <button class="btn btn-sm btn-outline-danger ml-2" type="button" (click)="emitaGerarPixOnlineTuna()">
      Ver / Cancelar Pix
    </button>
  </div>

  <ng-container *ngIf="!multiplasFormasPagamentos">
    <p class="instrucao-forma-pagamento">Selecione a forma de pagamento</p>

    <div class="metodos-grid" [class.com-erro]="exibeErroCategoriaPagamento()">
      <button type="button"
              class="metodo-card"
              *ngFor="let categoria of categorias; trackBy: rastreieCategoria"
              [class.ativo]="tipoCategoriaSelecionada === categoria.tipo"
              [ngClass]="obtenhaClasseCor(categoria)"
              (click)="selecioneCategoriaPorTipo(categoria.tipo, $event)">
        <span class="metodo-icone"><i [class]="categoria.icon"></i></span>
        <span class="metodo-label">{{categoria.label}}</span>
      </button>
    </div>

    <div class="erro-pagamento-controle erro-metodos" *ngIf="exibeErroCategoriaPagamento()">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{erroPagamentoControle}}</span>
    </div>

    <div class="formas-categoria-bloco" *ngIf="exibeEscolhaForma()" [class.com-erro]="exibeErroEscolhaForma()">
      <div class="formas-categoria-titulo">
        <div>
          <strong>{{tituloEscolhaForma()}}</strong>
          <small *ngIf="categoriaAtualEhPix()">{{obtenhaMensagemEscolhaForma()}}</small>
        </div>
        <span>{{categoriaSelecionada.label}}</span>
      </div>

      <div class="formas-categoria" [class.formas-categoria-horizontal]="exibeFormasCategoriaHorizontal()"
           [style.grid-template-columns]="obtenhaGridTemplateFormasCategoria()">
        <button type="button"
                class="forma-chip"
                *ngFor="let forma of categoriaSelecionada.formas"
                [class.ativo]="formaEstaSelecionada(forma)"
                (click)="selecioneFormaDaCategoria(forma)">
          <span class="forma-chip-imagem" *ngIf="obtenhaImagemBandeira(forma); else iconeBandeira">
            <span class="forma-chip-svg" *ngIf="ehImagemSvgBandeira(forma)" [innerHTML]="obtenhaSvgBandeira(forma)"></span>
            <img *ngIf="!ehImagemSvgBandeira(forma)" [src]="obtenhaImagemBandeira(forma)" [alt]="obtenhaNomeBandeira(forma)">
          </span>
          <ng-template #iconeBandeira>
            <span class="forma-chip-icone"><i [class]="obtenhaIconeForma(forma)"></i></span>
          </ng-template>
          <span class="forma-chip-texto">
            <strong>{{obtenhaNomeBandeira(forma)}}</strong>
            <small *ngIf="categoriaAtualEhPix()">{{obtenhaDescricaoOpcaoPix(forma)}}</small>
            <span class="forma-chip-marcadores" *ngIf="formaTemTaxa(forma) || formaTemDesconto(forma)">
              <span class="forma-chip-badge forma-chip-badge-taxa" *ngIf="formaTemTaxa(forma)">
                {{obtenhaDescricaoTaxaForma(forma)}}
              </span>
              <span class="forma-chip-badge forma-chip-badge-desconto" *ngIf="formaTemDesconto(forma)">
                {{obtenhaDescricaoDescontoForma(forma)}}
              </span>
            </span>
          </span>
          <span class="forma-chip-check"><i class="fas fa-check"></i></span>
        </button>
      </div>

      <div class="erro-pagamento-controle" *ngIf="exibeErroEscolhaForma()">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{erroPagamentoControle}}</span>
      </div>
    </div>

    <div class="pagamento-detalhe"
         *ngIf=" categoriaAtualEhDinheiro()"
         [class.detalhe-dinheiro]="categoriaAtualEhDinheiro()"
         [class.detalhe-pix]="categoriaAtualEhPix()">
      <div class="detalhe-info">
        <span class="detalhe-icone" [ngClass]="obtenhaClasseCor(categoriaSelecionada)">
          <i [class]="categoriaSelecionada.icon"></i>
        </span>
        <div>
          <strong>{{tituloDetalhePagamento()}}</strong>
          <small>{{descricaoDetalhePagamento()}}</small>
          <span class="forma-chip-marcadores detalhe-forma-marcadores"
                *ngIf="formaTemTaxa(formaDePagamentoEscolhida) || formaTemDesconto(formaDePagamentoEscolhida)">
            <span class="forma-chip-badge forma-chip-badge-taxa" *ngIf="formaTemTaxa(formaDePagamentoEscolhida)">
              {{obtenhaDescricaoTaxaForma(formaDePagamentoEscolhida)}}
            </span>
            <span class="forma-chip-badge forma-chip-badge-desconto" *ngIf="formaTemDesconto(formaDePagamentoEscolhida)">
              {{obtenhaDescricaoDescontoForma(formaDePagamentoEscolhida)}}
            </span>
          </span>
        </div>
      </div>

      <div class="detalhe-campos" *ngIf="categoriaAtualEhDinheiro(); else pagamentoSimples">
        <label>
          <span>Valor recebido</span>
          <kendo-numerictextbox name="trocoParaMetodo"
                                format="c2"
                                appRemovaWheel
                                class="form-control"
                                [(ngModel)]="trocoPara"
                                [min]="valorMinimoDinheiro()"
                                (ngModelChange)="calculeTroco()">
          </kendo-numerictextbox>
        </label>

        <span class="seta-troco"><i class="fas fa-arrow-right"></i></span>

        <label>
          <span>Troco para o cliente</span>
          <div class="troco-valor">{{troco | currency:'BRL'}}</div>
        </label>
      </div>

      <ng-template #pagamentoSimples>
        <div class="detalhe-confirmacao" *ngIf="formaDePagamentoEscolhida?.id">
          <div class="confirmacao-forma">
            <span>Selecionado</span>
            <strong>{{formaDePagamentoEscolhida.descricao}}</strong>
          </div>
          <div class="confirmacao-valor">
            <span>Valor</span>
            <strong>{{totalPagar | currency:'BRL'}}</strong>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="pix-online-card" *ngIf="pixOnlineTunaSelecionado()" [class.com-erro]="exibeErroPixOnline()">
      <span class="pix-online-card-icone"><i class="fas fa-qrcode"></i></span>
      <div>
        <strong>Gerar QR Code Pix</strong>
        <small>Clique no botão para gerar o QR Code e apresentar ao cliente para pagamento.</small>
        <small>QR Code será gerado agora.</small>
        <span class="erro-pagamento-inline" *ngIf="exibeErroPixOnline()">
          <i class="fas fa-exclamation-circle"></i>
          {{erroPagamentoControle}}
        </span>
      </div>
      <button class="btn btn-primary" type="button"
              (click)="selecionePixOnlineTuna(); emitaGerarPixOnlineTuna()"
              [disabled]="pagamentoBloqueadoPorPixOnline()">
        <i class="fas fa-qrcode mr-1"></i> Gerar QR Code Pix
      </button>
    </div>

    <div class="pix-online-info" *ngIf="pixOnlineTunaSelecionado()">
      <i class="fas fa-info-circle"></i>
      <span>Após o cliente realizar o pagamento, confirme para finalizar a comanda.</span>
    </div>

    <div class="adicionar-outra-forma" *ngIf="podeAdicionarOutraFormaPagamento()">
      <button type="button" (click)="adicioneOutraFormaPagamento()">
        <i class="fas fa-plus"></i>
        <span>Adicionar outra forma (dividir pagamento)</span>
      </button>
    </div>

  </ng-container>

  <ng-container *ngIf="multiplasFormasPagamentos">
    <div class="pagamentos-divididos" *ngIf="pagamentos.length">
      <div class="pagamento-dividido-card" *ngFor="let pagamento of pagamentos; let indice = index"
           [class.removido]="pagamento.removido"
           [class.ativo]="pagamentoDivididoEstaSelecionado(pagamento)"
           (click)="selecionouPagamentoDividido(pagamento)">
        <div class="pagamento-dividido-topo">
          <strong>Pagamento {{indice + 1}}</strong>
          <button type="button" class="btn-remover" (click)="removaPagamentoComanda(pagamento); $event.stopPropagation()">
            <i class="fas fa-trash"></i>
          </button>
        </div>

        <div class="pagamento-dividido-corpo">
          <div class="pagamento-dividido-forma">
            <span class="forma-mini-icone"><i [class]="obtenhaIconeForma(pagamento.formaDePagamento)"></i></span>
            <span class="pagamento-dividido-forma-texto">
              <span>{{pagamento.formaDePagamento.descricao}}</span>
              <span class="forma-chip-marcadores" *ngIf="formaTemTaxa(pagamento.formaDePagamento) || formaTemDesconto(pagamento.formaDePagamento)">
                <span class="forma-chip-badge forma-chip-badge-taxa" *ngIf="formaTemTaxa(pagamento.formaDePagamento)">
                  {{obtenhaDescricaoTaxaForma(pagamento.formaDePagamento)}}
                </span>
                <span class="forma-chip-badge forma-chip-badge-desconto" *ngIf="formaTemDesconto(pagamento.formaDePagamento)">
                  {{obtenhaDescricaoDescontoForma(pagamento.formaDePagamento)}}
                </span>
              </span>
            </span>
          </div>
          <label class="pagamento-dividido-valor"
                 [class.com-erro]="pagamentoSemTrocoExcedeuTotal(pagamento)">
            <span>Valor</span>
            <kendo-numerictextbox name="valorPagamentoDividido{{indice}}"
                                  format="c2"
                                  appRemovaWheel
                                  class="form-control"
                                  [(ngModel)]="pagamento.valorInformado"
                                  [min]="0"
                                  (ngModelChange)="alterouValorPagamentoDividido(pagamento, $event)">
            </kendo-numerictextbox>
            <small class="erro-pagamento-campo" *ngIf="pagamentoSemTrocoExcedeuTotal(pagamento)">
              {{obtenhaErroPagamentoSemTrocoExcedenteTotal()}}
            </small>
          </label>
        </div>

        <div class="pagamento-dividido-troco" *ngIf="pagamentoEhDinheiro(pagamento) && pagamento.trocoPara > pagamento.valor">
          Troco para o cliente: <strong>{{(pagamento.trocoPara - pagamento.valor) | currency:'BRL'}}</strong>
        </div>

        <div class="pagamento-dividido-sugestao" *ngIf="!pagamento.removido">
          <span>Valor restante pagamento: <strong>{{valorRestantePagamento(pagamento) | currency:'BRL'}}</strong></span>
          <button type="button" *ngIf="exibeBotaoUsarValorRestante()"
                  (click)="useValorRestantePagamento(pagamento, $event)">Usar</button>
        </div>
      </div>
    </div>

    <div class="adicionar-dividido" [class.chamar-atencao]="chamarAtencaoOutraForma">
      <p class="instrucao-forma-pagamento">Selecione a outra forma de pagamento</p>

      <div class="metodos-grid compacto" [class.com-erro]="exibeErroCategoriaPagamento()">
        <button type="button"
                class="metodo-card"
                *ngFor="let categoria of categorias; trackBy: rastreieCategoria"
                [class.ativo]="tipoCategoriaSelecionada === categoria.tipo"
                [ngClass]="obtenhaClasseCor(categoria)"
                (click)="selecioneCategoriaPorTipo(categoria.tipo, $event)">
          <span class="metodo-icone"><i [class]="categoria.icon"></i></span>
          <span class="metodo-label">{{categoria.label}}</span>
        </button>
      </div>

      <div class="erro-pagamento-controle erro-metodos" *ngIf="exibeErroCategoriaPagamento()">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{erroPagamentoControle}}</span>
      </div>

      <div class="formas-categoria-bloco" *ngIf="exibeEscolhaForma()" [class.com-erro]="exibeErroEscolhaForma()">
        <div class="formas-categoria-titulo">
          <div>
            <strong>{{tituloEscolhaForma()}}</strong>
            <small *ngIf="categoriaAtualEhPix()">{{obtenhaMensagemEscolhaForma()}}</small>
          </div>
          <span>{{categoriaSelecionada.label}}</span>
        </div>

        <div class="formas-categoria" [class.formas-categoria-horizontal]="exibeFormasCategoriaHorizontal()"
             [style.grid-template-columns]="obtenhaGridTemplateFormasCategoria()">
          <button type="button"
                  class="forma-chip"
                  *ngFor="let forma of categoriaSelecionada.formas"
                  [class.ativo]="formaEstaSelecionada(forma)"
                  (click)="selecioneFormaDaCategoria(forma)">
            <span class="forma-chip-imagem" *ngIf="obtenhaImagemBandeira(forma); else iconeBandeiraDividido">
              <span class="forma-chip-svg" *ngIf="ehImagemSvgBandeira(forma)" [innerHTML]="obtenhaSvgBandeira(forma)"></span>
              <img *ngIf="!ehImagemSvgBandeira(forma)" [src]="obtenhaImagemBandeira(forma)" [alt]="obtenhaNomeBandeira(forma)">
            </span>
            <ng-template #iconeBandeiraDividido>
              <span class="forma-chip-icone"><i [class]="obtenhaIconeForma(forma)"></i></span>
            </ng-template>
            <span class="forma-chip-texto">
              <strong>{{obtenhaNomeBandeira(forma)}}</strong>
              <small *ngIf="categoriaAtualEhPix()">{{obtenhaDescricaoOpcaoPix(forma)}}</small>
              <span class="forma-chip-marcadores" *ngIf="formaTemTaxa(forma) || formaTemDesconto(forma)">
                <span class="forma-chip-badge forma-chip-badge-taxa" *ngIf="formaTemTaxa(forma)">
                  {{obtenhaDescricaoTaxaForma(forma)}}
                </span>
                <span class="forma-chip-badge forma-chip-badge-desconto" *ngIf="formaTemDesconto(forma)">
                  {{obtenhaDescricaoDescontoForma(forma)}}
                </span>
              </span>
            </span>
            <span class="forma-chip-check"><i class="fas fa-check"></i></span>
          </button>
        </div>

        <div class="erro-pagamento-controle" *ngIf="exibeErroEscolhaForma()">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{erroPagamentoControle}}</span>
        </div>
      </div>

      <div class="alert alert-danger mt-2 mb-0" *ngIf="msgErroAdicionar">
        {{msgErroAdicionar}}
      </div>
    </div>

    <div class="resumo-divisao">
      <div>
        <span>Valor coberto</span>
        <strong>{{valorCoberturaInformada() | currency:'BRL'}}</strong>
      </div>
      <div *ngIf="totalDescontosPagamento() > 0">
        <span>Descontos</span>
        <strong>- {{totalDescontosPagamento() | currency:'BRL'}}</strong>
      </div>
      <div *ngIf="totalTaxasPagamento() > 0">
        <span>Taxas</span>
        <strong>{{totalTaxasPagamento() | currency:'BRL'}}</strong>
      </div>
      <div *ngIf="totalTaxasPagamento() > 0 || totalDescontosPagamento() > 0">
        <span>Total cobrado</span>
        <strong>{{valorInformado() | currency:'BRL'}}</strong>
      </div>
      <div>
        <span>Diferença</span>
        <strong [class.text-success]="diferencaPagamento() === 0"
                [class.text-danger]="diferencaPagamento() !== 0">
          {{diferencaPagamento() | currency:'BRL'}}
        </strong>
      </div>
      <div *ngIf="valorExcedente() > 0" class="text-danger">
        <span>Excedente</span>
        <strong>{{valorExcedente() | currency:'BRL'}}</strong>
      </div>
    </div>
  </ng-container>
</div>
